module.exports = __webpack_public_path__ + "media/images/icons/icon-megaphone-d1ea3926575a3e5fead7389e4fad89b1.svg";